import React, { useState } from 'react'; // Importing React and useState hook to manage local state
import { Link } from 'react-router-dom'; // Importing Link to navigate to another route
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Importing Chevron icons for expand/collapse functionality

// AccountLabel component accepts 'account' as a prop
const AccountLabel = ({ account }) => {
  // State to manage the expanded/collapsed state of the address section
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle the expanded/collapsed state
  const handleExpandClick = () => {
    setIsExpanded(!isExpanded); // Toggle isExpanded state
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ alignItems: 'center' }}>
        <p style={{ fontWeight: 'bold', fontSize: "18px" }}>Account:</p>
        
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Link to "TabsWorking" route with account name */}
          <Link 
            to="/TabsWorking" 
            style={{ textDecoration: "none", fontWeight: "normal", color: "#004aad", fontSize: "18px" }}
          >
            {account} {/* Displaying the account name passed as a prop */}
          </Link>

          {/* Chevron Button to expand/collapse address section */}
          <div 
            style={{                                   
              marginLeft: '10px',                        
              cursor: 'pointer',                          // Make it clickable
              backgroundColor: '#004aad',                // Button color
              color: 'white',                             
              padding: '5px 8px',                         
              borderRadius: '4px', 
              display: "flex", 
              alignItems: "center",                      // Center the icon
              justifyContent: "center",
            }} 
            onClick={handleExpandClick} // Trigger the toggle when clicked
          >
            {isExpanded ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />} {/* Show chevron up/down depending on state */}
          </div>
        </div>
      </div>

      {/* Conditionally rendered address section */}
      {isExpanded && (
        <div style={{ marginTop: "10px", paddingLeft: "15px", color: "#333", fontSize: "14px" }}>
          <p>2D VICARAGE ROAD</p>
          <p>BIRMINGHAM BIR GB B14 7RA</p>
          <p>Phone: 0121 444 0496</p>
          <p>Email: Communications@allsaintsdentalclinic.co.uk</p>
        </div>
      )}
    </div>
  );
};

export default AccountLabel; 
